/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  task = 1,
  rank,
}

export enum TaskTypeEnum {
  收礼人数,
  上麦人数,
}
export async function una_notice(params) {
  const res = await http.post(
    '/live/activity/una_notice',
    {...params},
    {
      store: window.store,
    }
  )
  return res.data.data
}

// 公会新主播任务详情 http://wiki.xunlei.cn/pages/viewpage.action?pageId=105293978
export const una_union_job_detail = createAsyncThunk(
  'una_union_job_detail',
  async (arg: {type: TaskTypeEnum}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'valid_anchor_num'
          | 'stage_tasks'
          | 'activity_range'
          | 'invalid_anchors'
          | 'can_role_view'
          | 'valid_income_target'
        >
      >
    >('/live/activity/una_union_job_detail', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

interface InitialStateType {
  valid_anchor_num?: number
  can_role_view?: boolean
  stage_tasks?: any[]
  activity_range?: string[]
  invalid_anchors?: any[]
  valid_income_target?: number
  can_notice?: boolean
  first_enter_after_join?: boolean
  is_union_leader?: boolean
}

const initialState: InitialStateType = {}

export const StarHunterSlice = createSlice({
  name: 'StarHunterV2',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(una_union_job_detail.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default StarHunterSlice.reducer
export const StarHunterActions = StarHunterSlice.actions
